import React from 'react';
import { Button } from './ui/button';
import { ArrowRight } from 'lucide-react';

export const CTASection = () => {
  const handleBookDemo = () => {
    const subject = encodeURIComponent("Anmodning om demo - MUSEIQ");
    const body = encodeURIComponent("Hej MuseIQ\n\nJeg vil gerne booke en demo af jeres løsning.\n\nI må meget gerne kontakte mig for at aftale et tidspunkt.\n\nBedste hilsner\n[Navn]\n[Virksomhed]");
    window.location.href = `mailto:Kasper@museiq.io?subject=${subject}&body=${body}`;
  };

  return (
    <section data-testid="cta-section" className="cta-section-surface py-12 md:py-16">
      <div className="container-custom relative z-10">
        <div className="max-w-2xl mx-auto text-center text-white">
          <h2 className="text-3xl md:text-4xl font-heading font-bold mb-5">
            Klar til at gøre jeres events mere effektive?
          </h2>
          <p className="text-lg text-white/85 mb-8 leading-relaxed">
            Book en personlig demo og se hvordan MUSEIQ kan hjælpe jer med kortere køer, bedre overblik og mere effektiv drift.
          </p>
          <Button
            data-testid="cta-book-demo"
            size="lg"
            className="cta-button-neutral group"
            onClick={handleBookDemo}
          >
            Book en demo
            <ArrowRight className="ml-2 h-4 w-4 group-hover:translate-x-1 transition-transform" />
          </Button>
        </div>
      </div>
    </section>
  );
};
